class PdpVideo extends HTMLElement {
  constructor() {
    super();

    this.video = this.querySelector("video");
    this.muteButton = this.querySelector("button.volume");
    if (!this.video) return;

    this.handleMute();
  }

  handleMute() {
    if (!this.muteButton) return;

    this.video.addEventListener("volumechange", () => {
      this.dataset.muted = this.video.muted;
    });

    this.muteButton.addEventListener("click", () => {
      this.video.muted = !this.video.muted;
    });
  }
}

customElements.define("pdp-video", PdpVideo);
